import TermsModalWrapper from './TermsModalWrapper'
export default TermsModalWrapper
